var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconResumeDoneGreen = function SvgIconResumeDoneGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.333 7H11.667a2.333 2.333 0 0 0-2.334 2.333v37.334A2.333 2.333 0 0 0 11.667 49h32.666a2.333 2.333 0 0 0 2.334-2.333V9.333A2.333 2.333 0 0 0 44.333 7Z",
    fill: "#15C480"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.188 35.292a1.604 1.604 0 0 0 0-3.208H18.811a1.604 1.604 0 1 0 0 3.208h18.375ZM37.188 42a1.604 1.604 0 0 0 0-3.209H18.811a1.604 1.604 0 1 0 0 3.208h18.375Z",
    fill: "#9EEED3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.002 19.915a2.958 2.958 0 1 0 0-5.915 2.958 2.958 0 0 0 0 5.915ZM32.23 26.25h-8.458a1.28 1.28 0 0 1-1.246-1.618c.691-2.369 2.879-3.958 5.475-3.958 2.595 0 4.783 1.59 5.474 3.958a1.28 1.28 0 0 1-1.245 1.618Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.042 54.833c5.96 0 10.791-4.831 10.791-10.791S50.002 33.25 44.042 33.25 33.25 38.082 33.25 44.042s4.832 10.791 10.792 10.791Z",
    fill: "#FFC82A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m44.422 48.066 5.166-5.943a1.604 1.604 0 0 0-2.421-2.105L42 45.96a1.604 1.604 0 1 0 2.422 2.105Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m44.346 45.879-3.506-3.506a1.604 1.604 0 0 0-2.27 2.268l3.507 3.506a1.604 1.604 0 1 0 2.269-2.268Z",
    fill: "#fff"
  })));
};
export default SvgIconResumeDoneGreen;